import React from "react";
import { NavLink, useNavigate, Link } from "react-router-dom";
import { FileText, Newspaper, Users, LogOut, ExternalLink, Palette, Search } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import SEO from "../seo/SEO";

const linkCls = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
    isActive ? "bg-sage text-white" : "text-ink-soft hover:bg-cream-2"
  }`;

export const AdminLayout = ({ children }) => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-cream flex">
      <SEO title="Admin — Karen Boley Counselling" noindex />
      <aside className="w-64 shrink-0 border-r border-cream-2 bg-white p-5 flex flex-col fixed h-full">
        <div className="mb-8">
          <p className="font-serif text-2xl text-ink">Karen Boley</p>
          <p className="text-xs text-ink-muted">Admin dashboard</p>
        </div>
        <nav className="space-y-1 flex-1">
          <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-content"><FileText className="h-4 w-4" /> Content</NavLink>
          <NavLink to="/admin/theme" className={linkCls} data-testid="admin-nav-theme"><Palette className="h-4 w-4" /> Theme</NavLink>
          <NavLink to="/admin/blog" className={linkCls} data-testid="admin-nav-blog"><Newspaper className="h-4 w-4" /> Blog</NavLink>
          <NavLink to="/admin/seo" className={linkCls} data-testid="admin-nav-seo"><Search className="h-4 w-4" /> SEO</NavLink>
          <NavLink to="/admin/admins" className={linkCls} data-testid="admin-nav-admins"><Users className="h-4 w-4" /> Admins</NavLink>
        </nav>
        <div className="space-y-1 border-t border-cream-2 pt-3">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-ink-soft hover:bg-cream-2"><ExternalLink className="h-4 w-4" /> View site</Link>
          <button data-testid="admin-logout" onClick={doLogout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-ink-soft hover:bg-cream-2"><LogOut className="h-4 w-4" /> Log out</button>
          <p className="px-4 pt-2 text-xs text-ink-muted truncate">{admin?.email}</p>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8">{children}</main>
    </div>
  );
};

export default AdminLayout;
